import LangSwitcher from '../../components/LangSwitch/langSwitcher'
/**
=========================================================
* Template for Auth
=========================================================
*/ 

// Soft UI Dashboard React context 

function AuthLayout({ children }) {  
  return(
    <div className="auth-wrapper">
      <div className="auth-content container">
        <div className="hello-login">
          <p>WELCOME</p>
          <h2>MYBUDAPESTER.COM</h2>
          <p>Marketplace Technology</p>
        </div>
        <div className="card">
			    <div className="row align-items-center"> 
             
              {children}  
          </div> 
        </div>
        <div className='lang-box'>
        <LangSwitcher></LangSwitcher>
        </div>
      </div>	   
    </div>  
  );
} 

export default AuthLayout;